export default "__VITE_PUBLIC_ASSET__f8fa92e5__"